import React from 'react';
import { Link } from 'react-router-dom';

import CompImage1 from '@app/dev/images/favoriteCompetitions/fav-comp-1.png';
import CompImage2 from '@app/dev/images/favoriteCompetitions/fav-comp-2.png';
import CompImage3 from '@app/dev/images/favoriteCompetitions/fav-comp-3.png';
import zaxComp1 from '@app/dev/images/favoriteCompetitions/zax-fav-comp-1.png';
import zaxComp2 from '@app/dev/images/favoriteCompetitions/zax-fav-comp-2.png';
import zaxComp3 from '@app/dev/images/favoriteCompetitions/zax-fav-comp-3.png';
import whiterabbitbetComp1 from '@app/dev/images/favoriteCompetitions/whiterabbitbet-fav-comp-1.jpg';
import whiterabbitbetComp2 from '@app/dev/images/favoriteCompetitions/whiterabbitbet-fav-comp-2.jpg';
import whiterabbitbetComp3 from '@app/dev/images/favoriteCompetitions/whiterabbitbet-fav-comp-3.jpg';
import bcComp1 from '@app/dev/images/favoriteCompetitions/bc-comp-1.png';
import bcComp2 from '@app/dev/images/favoriteCompetitions/bc-comp-2.png';
import bcComp3 from '@app/dev/images/favoriteCompetitions/bc-comp-3.jpg';

import { useTranslation } from '@common/hooks/translation';

import './style.scss';
import Config from '@app/dev/config/main';

const mockImages = {
  1: CompImage1,
  2: CompImage2,
  3: CompImage3,
  4: zaxComp1,
  5: zaxComp2,
  6: zaxComp3,
  7: whiterabbitbetComp1,
  8: whiterabbitbetComp2,
  9: whiterabbitbetComp3,
  10: bcComp1,
  11: bcComp2,
  12: bcComp3,
};

const FavoriteCompetitions = () => {
  const t = useTranslation();

  return (
    <div className="home-favorite-competitions">
      {Config.main.homeFavoritCompetitions.map((comp) => (
        <Link
          key={comp.id}
          to={comp.url}
          style={{ background: `url('${mockImages[comp.id]}') center/cover` }}
        >
          <p className={comp.classname} />
          {t(comp.name)}
        </Link>
      ))}
    </div>
  );
};

export default FavoriteCompetitions;
